import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
type MetricTileProps = {
  label: string;
  value: string;
  caption: string;
  tone?: 'count' | 'volume';
  onOpen: () => void;
  disabled?: boolean;
};
export function MetricTile({
  label,
  value,
  caption,
  tone = 'count',
  onOpen,
  disabled
}: MetricTileProps) {
  return <button type="button" onClick={onOpen} disabled={disabled} className="group flex h-full w-full flex-col rounded-xl border border-gray-200 bg-white px-5 py-4 text-left transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-brand/30 disabled:cursor-default disabled:hover:shadow-none" data-id="element-395" data-mp="311gvfktw8it9">
      <div className="flex items-center gap-2" data-id="element-396" data-mp="3orkstaghnmbt">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500" data-id="element-397" data-mp="3jplu4dvp1dl7">
          {label}
        </p>
        {!disabled && <ArrowUpRightIcon className="ml-auto h-3.5 w-3.5 text-gray-300 transition-colors group-hover:text-brand" aria-hidden="true" data-id="element-398" data-mp="2d88f1rp6cezz" />}
      </div>
      <p className={['mt-3 font-bold leading-none', tone === 'volume' ? 'text-[26px] text-navy' : 'text-[34px] text-brand'].join(' ')} data-id="element-399" data-mp="1wru3rw18sczk">
        {value}
      </p>
      <p className="mt-auto pt-3 text-[12px] text-gray-500" data-id="element-400" data-mp="1my4woz12lqk6">{caption}</p>
    </button>;
}